import React, { useEffect, useRef } from 'react'

const REACT_MODAL_SELECTOR = '.ReactModalPortal, .ReactModal__Overlay, .ReactModal__Content'

function isClickInModal(target: HTMLElement | null): boolean {
  return target?.closest(REACT_MODAL_SELECTOR) != null
}

export default function useClickOutside(
  ref: React.RefObject<HTMLElement | null>,
  callback: (e: MouseEvent) => void,
  enabled: boolean = true,
) {
  const callbackRef = useRef<any>(null)

  useEffect(() => {
    callbackRef.current = callback
  })

  useEffect(() => {
    if (enabled) {
      const handleClick = (e: MouseEvent) => {
        const target = e.target as HTMLElement
        if (
          target &&
          // if they clicked inside the element, don't trigger
          !ref.current?.contains(target) &&
          // don't treat clicks inside a modal as outside (e.g. closing modal shouldn't close dropdown)
          !isClickInModal(target) &&
          // make sure our element we're detecting was actually visible
          // can't "click outside" an invisible element
          // note: not supported by safari
          (ref.current?.checkVisibility?.() ?? true)
        ) {
          callbackRef.current(e)
        }
      }

      window.addEventListener('click', handleClick, true)

      return () => {
        window.removeEventListener('click', handleClick, true)
      }
    }
  }, [ref, enabled])
}
